function normalizeApplicableArea(value: string): string {
  return value.trim().toLowerCase();
}

export function canAddApplicableAreaRow(rows: string[]): boolean {
  return Boolean(rows[rows.length - 1]?.trim());
}

export function findDuplicateApplicableAreaIndices(rows: string[]): Set<number> {
  const seen = new Map<string, number>();
  const duplicates = new Set<number>();

  rows.forEach((row, index) => {
    const normalized = normalizeApplicableArea(row);
    if (!normalized) return;

    const firstIndex = seen.get(normalized);
    if (firstIndex !== undefined) {
      duplicates.add(firstIndex);
      duplicates.add(index);
    } else {
      seen.set(normalized, index);
    }
  });

  return duplicates;
}
